import { type App } from 'vue'

// import { increase } from './increase'
//
// /** 挂载自定义指令 */
// export function loadDirectives(app: App) {
//   app.directive('increase', increase)
// }

// import directiveIncrease from './increase.ts'
//
// export default function directives(app: App) {
//   directiveIncrease(app)
// }

import { increase } from './increase.ts'
import lazyImage from './lazy-load-img.ts'

// const List: any = {
//   increase,
//   vLazy: lazyLoad
// }

export const setupDirectives = app => {
  app.directive('lazy', lazyImage)

  // 可以在这里添加更多自定义指令
  // app.directive('another', anotherDirective)
}

// export default directives
